<div *ngIf="loadingTransactions" class="loading-mask">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="transactionDetail.length" class="p-4 space-y-6">
  <h2 class="text-2xl font-bold mb-4">{{ "TRANSACTIONS.DETAILS.HeaderTitle" | translate }}</h2>

  <div *ngFor="let tx of transactionDetail" class="space-y-6">

    <!-- Información General -->
    <mat-card>
      <mat-card-title style="text-align: center;">
        <p><strong>{{ "TRANSACTIONS.DETAILS.GeneralInfo" | translate }}</strong></p>
      </mat-card-title>
      <hr>
      <mat-card-content>
        <p><strong>{{ "TRANSACTIONS.DETAILS.ID" | translate }}:</strong> {{ tx.id }}</p>
        <p><strong>{{ "TRANSACTIONS.DETAILS.Date" | translate }}:</strong> {{ tx.createdAt }}</p>
        <p><strong>{{ "TRANSACTIONS.DETAILS.LastUpdate" | translate }}:</strong> {{ tx.updatedAt }}</p>
        <p><strong>{{ "TRANSACTIONS.DETAILS.Amount" | translate }}:</strong> {{ tx.amount | number:'1.4-4' }} {{ tx.currency }}</p>

        <p><strong>{{ "TRANSACTIONS.DETAILS.Source" | translate }}:</strong> {{ tx.source }}</p>
        <p><strong>{{ "TRANSACTIONS.DETAILS.Destination" | translate }}:</strong> {{ tx.destination }}</p>
        <p><strong>{{ "TRANSACTIONS.DETAILS.Status" | translate }}:</strong> {{ tx.type }}</p>
      </mat-card-content>
    </mat-card>

    <!-- Datos del Usuario -->
    <mat-card *ngIf="tx.userDetails">
      <mat-card-title style="text-align: center;">
        <p><strong>{{ "TRANSACTIONS.DETAILS.UserInfo" | translate }}</strong></p>
      </mat-card-title>
      <hr>
      <mat-card-content>
        <p><strong>{{ "TRANSACTIONS.DETAILS.Email" | translate }}:</strong> {{ tx.userDetails.email }}</p>
        <p><strong>{{ "TRANSACTIONS.DETAILS.EmailVerified" | translate }}:</strong> {{ tx.userDetails.email_verified }}</p>
        <p><strong>{{ "TRANSACTIONS.DETAILS.Phone" | translate }}:</strong> {{ tx.userDetails.phone_number }}</p>
        <p><strong>{{ "TRANSACTIONS.DETAILS.PhoneVerified" | translate }}:</strong> {{ tx.userDetails.phone_number_verified }}</p>
        <p><strong>{{ "TRANSACTIONS.DETAILS.Name" | translate }}:</strong> {{ tx.userDetails.name }} {{ tx.userDetails.middle_name }}</p>
        <p>
          <strong>{{ "TRANSACTIONS.DETAILS.Address" | translate }}:</strong>
          {{ tx.userDetails["custom:address"] }},
          {{ tx.userDetails["custom:ciudad"] }},
          {{ tx.userDetails["custom:provincia"] }},
          {{ tx.userDetails["custom:country"] }}
        </p>
      </mat-card-content>
    </mat-card>

    <!-- Información TPV -->
    <mat-card *ngIf="tx.source === 'tpv' && tx.info?.DS_MERCHANT_PRODUCTDESCRIPTION">
      <mat-card-title style="text-align: center;">
        <p><strong>{{ "TRANSACTIONS.DETAILS.TPVInfo" | translate }}</strong></p>
      </mat-card-title>
      <hr>
      <mat-card-content>
        <p><strong>{{ "TRANSACTIONS.DETAILS.Service" | translate }}:</strong> {{ tx.info.DS_MERCHANT_PRODUCTDESCRIPTION }}</p>
        <p><strong>{{ "TRANSACTIONS.DETAILS.Quantity" | translate }}:</strong> {{ tx.info.DS_MERCHANT_AMOUNT }}</p>
        <p><strong>{{ "TRANSACTIONS.DETAILS.Order" | translate }}:</strong> {{ tx.info.DS_MERCHANT_ORDER }}</p>
      </mat-card-content>
    </mat-card>

  </div>
</div>

<div *ngIf="!transactionDetail.length && !loadingTransactions">
  <p>{{ "TRANSACTIONS.DETAILS.NotFound" | translate }}</p>
</div>
